import AuthService from "../login/auth.service";
import { basaSipacoop, comprobantes } from "../../components/generico/utils/UrlAPI";
import axios from "axios";

class ReimpresionInterentidadService {

  async reimprimirLista(cedula, mes) {
    var data = JSON.stringify({ cedula: cedula, mes: mes });
    var config = {
      method: "post",
      url: basaSipacoop + "reimprimir/v2/transferencia",
      data: data,
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + AuthService.getCurrentToken(),
      },
    };
    return await axios(config);
  }

  async descagarComponente(
    _titulo,
    _nroOperacion,
    _cuentaTitular,
    _tipo,
    _moneda,
    _cuentaDebito,
    _cuentaCredito,
    _importeDebito,
    _importeCredito,
    _titularCuentaDestino,
    _entidad,
    _fechaOperacion,
    _tipoDocumentoDestino,
    _documentoDestino, 
    _motivo
  ) {
    var data = JSON.stringify({
      titulo: _titulo,
      nroOperacion: _nroOperacion,
      cuentaTitular: _cuentaTitular,
      tipo: _tipo,
      moneda: _moneda,
      cuentaDebito: _cuentaDebito,
      cuentaCredito: _cuentaCredito,
      importeDebito: _importeDebito,
      importeCredito: _importeCredito,
      titularCuentaDestino: _titularCuentaDestino,
      entidad: _entidad,
      fechaOperacion: _fechaOperacion,
      tipoDocumentoDestino: _tipoDocumentoDestino,
      documentoDestino: _documentoDestino,
      motivo : _motivo
    });

    var _url = comprobantes + "comprobantes/v2/reimpresion/transferencias-interbancarias" ;    
    var config = {
      method: "POST",
      url: _url,
      data: data,
      responseType: "blob",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + AuthService.getCurrentToken(),
      },
    };
    return await axios(config);
  }
  async descagarAhorroProgramadoComponente(
    _titulo,
    _nroOperacion,
    _cuentaTitular,
    _tipo,
    _moneda,
    _cuentaDebito,
    _cuentaCredito,
    _importeDebito,
    _importeCredito,
    _titularCuentaDestino,
    _entidad,
    _fechaOperacion,
    _tipoDocumentoDestino,
    _documentoDestino, 
    _motivo
  ) {
    var data = JSON.stringify({
      titulo: _titulo,
      nroOperacion: _nroOperacion,
      cuentaTitular: _cuentaTitular,
      tipo: _tipo,
      moneda: _moneda,
      cuentaDebito: _cuentaDebito,
      cuentaCredito: _cuentaCredito,
      importeDebito: _importeDebito,
      importeCredito: _importeCredito,
      titularCuentaDestino: _titularCuentaDestino,
      entidad: _entidad,
      fechaOperacion: _fechaOperacion,
      tipoDocumentoDestino: _tipoDocumentoDestino,
      documentoDestino: _documentoDestino,
      motivo : _motivo
    });

    var _url = comprobantes + "comprobantes/reimpresion/transferencias" ;   
  // var _url = " http://localhost:8080/comprobantes/reimpresion/transferencias" ;    
  
    var config = {
      method: "POST",
      url: _url,
      data: data,
      responseType: "blob",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + AuthService.getCurrentToken(),
      },
    };
    return await axios(config);
  }


}
export default new ReimpresionInterentidadService();
